import challenges from "../../../assets/img/challenges.svg"
import activities from "../../../assets/img/activities.svg"
import resources from "../../../assets/img/resources.svg"
import trophy from "../../../assets/img/trophy.svg"
import icons from "../../../assets/img/icons.svg"
import hraq from "../../../assets/img/hraQ.svg"
import hrad from "../../../assets/img/hraD.svg"
import graph from "../../../assets/img/graph.svg"

export const menuContent = [
  {
    url: "/admin/content-management/challenge",
    icon: challenges,
    title: "Challenges",
    description: "Create and customize user challenges for engagement",
  },
  {
    url: "/admin/content-management/resources",
    icon: resources,
    title: "Resources",
    description: "Upload and organize educational or support materials",
  },
  {
    url: "/admin/content-management/activity",
    icon: activities,
    title: "Activities",
    description: "Define tasks and interactions available to users",
  },
  {
    url: "/admin/content-management/trophy",
    icon: trophy,
    title: "Trophies Settings",
    description: "Configure rewards and achievements for user progress",
  },
  {
    url: "/admin/content-management/icons",
    icon: icons,
    title: "Icons Settings",
    description: "Manage custom icons used across the platform",
  },
  {
    url: "/admin/content-management/hraadmin",
    icon: graph,
    title: "Graph Settings",
    description: "Control visual data representation and graph configurations",
  },
  {
    url: "/admin/content-management/question",
    icon: hraq,
    title: "HRA Questions",
    description: "Edit and manage health risk assessment questions",
  },
  {
    url: "/admin/content-management/dimension",
    icon: hrad,
    title: "HRA Dimensions",
    description: "Define categories and scoring logic for HRA results",
  },

]